import { useTheme } from '@aws-amplify/ui-react';
export const AppTheme = () => {
  const { tokens } = useTheme();
  return {
    name: 'AppTheme',
    tokens: {
      components: {
        button: {
          primary: {
            backgroundColor: tokens.colors.blue['80'],
          },
          link: {
            color: tokens.colors.blue['80'],
          }
        },
        tabs: {
          item: {
            color: tokens.colors.blue['80'],
            _active: {
              borderColor: tokens.colors.blue['100'],
              color: tokens.colors.blue['100'],
            },
          },
        },
      }
    }
  }
};